import './HeroSection.scss'

const HeroSection = () => (
  <section className="lnn-section lnn-heroSection">
    <div className="lnn-shell lnn-heroSection__layout" data-reveal="up">
      <div className="lnn-heroSection__copy">
        <h1>Leadership Breaks Where Decisions Become Action</h1>
        <p>Organizations invest heavily in making the right decisions.</p>
        <p>Far fewer understand what happens when those decisions are translated into action.</p>
        <p>That is where failure begins.</p>
        <a
          className="lnn-ctaLink"
          href="https://leaderbridge.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Explore LeaderBridge
        </a>
      </div>

      <aside className="lnn-heroSection__network" aria-hidden="true">
        <div className="lnn-heroSection__node lnn-heroSection__node--root" />
        <div className="lnn-heroSection__line lnn-heroSection__line--v" />
        <div className="lnn-heroSection__line lnn-heroSection__line--h" />
        <div className="lnn-heroSection__node lnn-heroSection__node--a" />
        <div className="lnn-heroSection__node lnn-heroSection__node--b" />
        <div className="lnn-heroSection__node lnn-heroSection__node--c" />
      </aside>
    </div>
  </section>
)

export default HeroSection
